module.exports = __webpack_public_path__ + "img/hr-transition-3.38b48df9.png";